import React, { forwardRef, useImperativeHandle } from "react";
import { buildName } from "helper/tools";
import { format, parseJSON } from "date-fns";

/**
 * https://dev.to/graciesharma/implementing-csv-data-export-in-react-without-external-libraries-3030
 */
const ExportCSV = forwardRef(({ data, fileName }, ref) => {
  //({ data, fileName }) => {
  const downloadCSV = () => {
    // Convert the data array into a CSV string
    const csvString = [
      [
        "Id",
        "Cliente",
        "Asociado",
        "Fecha Orden",
        "Bodega",
        "Estado",
        "Bodega",
        "Estado",
        "Entrega",
        "Fecha Entrega",
        "Estatus",
      ], // Specify your headers here
      ...data.map((item) => {
        const id = item.id;
        const infoCliente = item.cliente ?? item.asociado;
        const ordenDate = format(item.fechaOrden, "dd/MM/yy hh:mm a");
        const fechaEntregaDate = item.fechaEntrega
          ? format(item.fechaEntrega, "dd/MM/yy hh:mm a")
          : "-";

        return [
          id,
          buildName(infoCliente, infoCliente?.id),
          buildName(item.asociado, item.asociado?.id),
          ordenDate,
          item.estadoBodega?.nombre ?? "",
          item.estadoOrden?.nombre ?? "",
          item.tipoEntrega?.nombre ?? "",
          fechaEntregaDate,
          item.estatuOrden?.nombre ?? "",
        ];
      }),
    ] // Map your data fields accordingly
      .map((row) => row.join(","))
      .join("\n");

    // Create a Blob from the CSV string
    const blob = new Blob([csvString], { type: "text/csv" });

    // Generate a download link and initiate the download
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = fileName || "download.csv";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  const downloadCSVCustom = (data, fileName) => {
    // Convert the data array into a CSV string
    const csvString = [
      [
        "Id",
        "Cliente",
        "Asociado",
        "Fecha Orden",
        "Bodega",
        "Estado",
        "Bodega",
        "Estado",
        "Entrega",
        "Fecha Entrega",
        "Estatus",
      ], // Specify your headers here
      ...data.map((item) => {
        const id = item.id;
        const infoCliente = item.cliente ?? item.asociado;
        const ordenDate = format(item.fechaOrden, "dd/MM/yy hh:mm a");
        const fechaEntregaDate = item.fechaEntrega
          ? format(item.fechaEntrega, "dd/MM/yy hh:mm a")
          : "-";

        return [
          id,
          buildName(infoCliente, infoCliente?.id),
          buildName(item.asociado, item.asociado?.id),
          ordenDate,
          item.estadoBodega?.nombre ?? "",
          item.estadoOrden?.nombre ?? "",
          item.tipoEntrega?.nombre ?? "",
          fechaEntregaDate,
          item.estatuOrden?.nombre ?? "",
        ];
      }),
    ] // Map your data fields accordingly
      .map((row) => row.join(","))
      .join("\n");

    // Create a Blob from the CSV string
    const blob = new Blob([csvString], { type: "text/csv" });

    // Generate a download link and initiate the download
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = fileName || "download.csv";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  const downloadCSVRaw = (csvString, fileName) => {
    // Convert the data array into a CSV string

    // Create a Blob from the CSV string
    const blob = new Blob([csvString], { type: "text/csv" });

    // Generate a download link and initiate the download
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = fileName || "download.csv";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  useImperativeHandle(ref, () => ({
    toggleModal: () => {},
    modalId: () => {},
    downloadCSV: (csvString, fileName) => {
      downloadCSVRaw(csvString, fileName);
    },
  }));

  //return <button onClick={downloadCSV}>Export CSV</button>;
  return <></>;
});

export default ExportCSV;
